"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemErrorPopover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const RedeemErrorPopoverContent_1 = require("../RedeemErrorPopoverContent/RedeemErrorPopoverContent");
function RedeemErrorPopover({ icon, organisationImageUrl, title, description, ctaButtonText, onClose, onSubmit, }) {
    const isLandscape = (0, ui_1.useOrientation)();
    const { isMobile } = (0, device_1.usePlatform)();
    let topContainer = icon;
    let topContainerStyle = undefined;
    const shouldShowOrganisationImage = ((!isLandscape && isMobile) || !isMobile) && organisationImageUrl;
    if (shouldShowOrganisationImage) {
        topContainer = ((0, jsx_runtime_1.jsx)(OrganisationalImage, { src: organisationImageUrl, alt: "Organisation logo", "data-e2e": 'RedeemErrorPopover_OrganisationalImage' }));
        topContainerStyle = { padding: 0 };
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.CTAPopup, { isOpen: true, onClose: onClose, topContainer: topContainer, topContainerStyle: topContainerStyle, "data-e2e": 'RedeemErrorPopover_CTAPopup', children: (0, jsx_runtime_1.jsx)(RedeemErrorPopoverContent_1.RedeemErrorPopoverContent, { title: title, description: description, CTAButtonText: ctaButtonText, onSubmit: onSubmit, "data-e2e": 'RedeemErrorPopover_RedeemErrorPopoverContent' }) }));
}
exports.RedeemErrorPopover = RedeemErrorPopover;
const OrganisationalImage = styled_components_1.default.img `
  height: 188px;
  width: 100%;
  object-fit: contain;
`;
